import { memo } from 'react';

/**
 * 작은 완료 링 — done/total 채움. total=0 → 회색 빈 링(「—」).
 * 측정 게이지 아님 — 현재 발생분 완료 글랜스 전용.
 */
export const ProgressRing = memo(function ProgressRing({ done = 0, total = 0, size = 46, stroke = 5, showText = true }) {
  const r = (size - stroke - 2) / 2;
  const c = 2 * Math.PI * r;
  const ratio = total > 0 ? done / total : 0;
  const cls = total === 0 ? 'pr-empty' : done >= total ? 'pr-full' : 'pr-partial';
  const cx = size / 2;
  return (
    <svg width={size} height={size} viewBox={`0 0 ${size} ${size}`}
      className={`progress-ring ${cls}`} role="img"
      aria-label={total > 0 ? `${done}/${total} 완료` : '발생 없음'}>
      <circle cx={cx} cy={cx} r={r} className="pr-track" fill="none" strokeWidth={stroke} />
      {total > 0 && done > 0 && (
        <circle cx={cx} cy={cx} r={r} className="pr-fill" fill="none" strokeWidth={stroke}
          strokeDasharray={`${c * ratio} ${c}`} strokeLinecap="round"
          transform={`rotate(-90 ${cx} ${cx})`} />
      )}
      {showText && (
        <text x="50%" y="50%" className="pr-text" textAnchor="middle" dominantBaseline="central">
          {total > 0 ? `${done}/${total}` : '—'}
        </text>
      )}
    </svg>
  );
});
